export const email_reg = `^[\w\.-]+@[a-zA-Z\d-]+(\.[a-zA-Z\d-]+)*\.[a-zA-Z]{2,}$`;
export const baseUrl = "https://bigdrum.veramasa.com/";

var today = new Date();
today.setHours(today.getHours() - 6);

export const time6 = today;
